<template>
  <div class="dialog-app-panel" :class="formShow ? 'dialog-show' : ''">
    <app-panel
      :isExpand="formShow"
      :title="state === 1 ? '新增步骤' : '修改步骤'"
      @cancel="formClose"
    >
      <!-- <div class="config-dialog">
    <el-dialog
      :title="state === 1 ? '新增步骤' : '修改步骤'"
      v-ops:width="680"
      v-dialogDrag
      append-to-body
      :visible.sync="formShow"
      @close="formClose"
      class=""
      :close-on-click-modal="false"
    > -->
      <el-form :model="configForm" :rules="rules" ref="configForm" label-width="120px">
        <el-form-item label="步骤名称" prop="stepName">
          <el-input v-model="configForm.stepName" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="键盘操作类型" prop="operationKeyType">
          <el-select
            v-model="configForm.operationKeyType"
            placeholder="请选择"
            style="width: 100%"
            @change="selectChange"
          >
            <el-option
              v-for="item in operateOption"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          label="固定输入内容"
          v-if="configForm.operationKeyType == 2"
          prop="inputContent"
        >
          <el-input
            type="textarea"
            readonly
            style="padding-right: 35px"
            :autosize="{ minRows: 2, maxRows: 4 }"
            placeholder="请选择键盘操作"
            v-model="configForm.inputContent"
          >
          </el-input>
          <el-button
            type="text"
            @click="backConfigForm"
            style="position: absolute; top: 12px; right: 0px; z-index: 2; font-size: 15px"
            >回退</el-button
          >
        </el-form-item>
      </el-form>
      <!-- 根据控制器类型展示不同的控制器 -->
      <!-- 设备 -->
      <el-scrollbar
        class="dialog-scroll"
        v-show="configForm.operationKeyType === '2'"
        style="height: calc(100% - 150px)"
      >
        <div class="leftTop" style="padding: 12px">
          <!-- 物联网 -->
          <fireIndex2
            v-if="controlType == 2"
            ref="controlDevice"
            :detail="detail"
            @controlCallBack="controlCallBack"
          />
          <!-- new 键盘 -->
          <component
            :is="showTypeComponent(controlType)"
            ref="controlDevice"
            :deviceVersion="
              !detail.subDeviceMark ? detail.deviceVersion : detail.parentDeviceVersion
            "
            :deviceName="
              detail.subDeviceMark ? detail.parentThirdDeviceName : detail.deviceName
            "
            :fireType="$route.query.alarmType"
            @controlCallBack="controlCallBack"
          ></component>
        </div>
      </el-scrollbar>
      <div slot="footer" class="dialog-footer">
        <el-button type="info" @click="formClose" :loading="btnLoading">{{
          btnLoading ? "提交中" : "取消"
        }}</el-button>
        <el-button type="primary" @click="saveForm" :loading="btnLoading">
          {{ btnLoading ? "提交中" : "确定" }}
        </el-button>
      </div>
      <!-- </el-dialog> -->
    </app-panel>
  </div>
</template>
<script>
import { api } from "../api";
import { Dic } from "$utils";
import utils from "@src/common/utils";
import appPanel from "@src/components/business/app-panel/index.vue";
import fireIndex2 from "../../realTimeAlarm/components/fireTemplate/index2"; //物联网
import fireIndexGst from "../../realTimeAlarm/components/fireTemplate/GTS500"; //Gst5000
import GST200 from "../../realTimeAlarm/components/fireTemplate/GTS200-2"; //GST200
import fireIndexGstH from "../../realTimeAlarm/components/fireTemplate/GTS15000H"; //Gst15000H
export default {
  components: {
    appPanel,
    fireIndex2,
    // new 键盘
    GST200,
    fireIndexGst,
    fireIndexGstH,
  },
  name: "ConfigDialog",
  props: {
    showFooter: {
      type: Boolean,
      default: true,
    },
    state: {
      type: Number,
      default: "",
    },
    controlType: {
      // type: Number,
      default: "",
    },
    detail: {
      type: Object,
      default: () => {
        return {};
      },
    },
    deviceId: {
      // type: String,
      default: "",
    },
    stepInfo: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  data() {
    return {
      btnLoading: false,
      showModal: false,
      formShow: false,
      configForm: {
        stepName: "",
        operationKeyType: "2",
        inputContent: "",
      },
      test: "",
      operateOption: [
        {
          value: "1",
          label: "键盘输入",
        },
        {
          value: "2",
          label: "固定输入",
        },
      ],
      deviceKey: "",
      respondText: "",
      tabValue: "",
      rules: {
        stepName: [
          { required: true, message: "请输入步骤名称", trigger: ["change", "blur"] },
        ],
        // operationKeyType: [
        //   { required: true, message: '请选择键盘操作类型', trigger: 'change' }
        // ],
        inputContent: [
          { required: true, message: "请填写", trigger: ["change", "blur"] },
        ],
      },
    };
  },
  mounted() {},
  methods: {
    showTypeComponent(val) {
      if (val == "GST5000") {
        return "fireIndexGst";
      } else if (val == "GST5000H") {
        return "fireIndexGstH";
      } else if (val == "GST200") {
        return "GST200";
      }
    },
    // 回退上一次输入
    backConfigForm() {
      if (this.configForm.inputContent) {
        let showList = this.configForm.inputContent.split(";");
        showList.splice(showList.length - 2, 1);
        this.configForm.inputContent = showList.join(";");

        let keyList = this.deviceKey.split(";");
        keyList.splice(keyList.length - 2, 1);
        this.deviceKey = keyList.join(";");
        this.$forceUpdate();
      }
    },
    open(value) {
      console.log(this.detail);
      console.log(this.controlType);
      if (this.controlType == 2) {
        this.$refs.controlDevice.getControlCodeOption();
      }
      this.formShow = true;
      this.tabValue = value;
      // 修改的时候需要回填
      // setTimeout(() => {
      if (this.state === 2) {
        this.configForm.stepName = this.stepInfo.stepName;
        this.configForm.operationKeyType = this.stepInfo.operationKeyType;
        this.deviceKey = this.stepInfo.inputContent;
        this.configForm.inputContent = this.stepInfo.inputContentStr
          ? this.stepInfo.inputContentStr + "; "
          : "";
        // let arr = [];
        // if (this.stepInfo.inputContent !== "") {
        //   this.stepInfo.inputContent.split(";").forEach((item, index) => {
        //     arr.push(Dic.findByValue("SENU098", item));
        //   });
        // }
        // arr[arr.length - 1] = arr[arr.length - 1] + ";";
        // this.configForm.inputContent = arr.join(";");
      }
      // }, 300);
    },
    controlCallBack(text, val) {
      // this.respondText = "";
      // this.respondText = Dic.findByValue("SENU098", val);
      this.respondText = "按键：" + text;
      this.deviceKey += val + ";";
      this.configForm.inputContent += this.respondText + "; ";
    },
    selectChange(val) {
      // if (val === '1') {
      //   this.stepInfo.operationKeyType === '1' ? this.configForm.inputContent = this.stepInfo.inputContent : this.configForm.inputContent = ''
      // } else {
      //   this.stepInfo.operationKeyType === '1' ? this.configForm.inputContent = '' : this.configForm.inputContent = this.stepInfo.inputContent;
      // }
    },
    // 保存按钮
    saveForm() {
      this.$refs["configForm"].validate((valid) => {
        if (valid) {
          let url =
            this.state === 1 ? api.config.addConfigStep : api.config.updateConfigStep;
          let params = {};
          if (this.state === 1) {
            // 新增
            params = {
              deviceId: this.deviceId,
              operationConfigType: this.tabValue,
              stepName: this.configForm.stepName,
              operationKeyType: this.configForm.operationKeyType,
              // inputContent: this.deviceKey.substring(0, this.deviceKey.lastIndexOf(';'))
              inputContent: this.configForm.operationKeyType == 2 ? this.deviceKey : "",
            };
            // let arr = [];
            // if (this.configForm.inputContent) {
            //   this.configForm.inputContent.split(";").forEach((item, index) => {
            //     if (item && item.length !== 0) {
            //       arr.push(Dic.findByLabel("SENU098", item));
            //     }
            //   });
            //   params.inputContent = arr.join(";");
            // }
          } else {
            // 修改
            params = {
              operationConfigCode: this.stepInfo.operationConfigCode,
              stepName: this.configForm.stepName,
              operationKeyType: this.configForm.operationKeyType,
              inputContent: this.configForm.operationKeyType == 2 ? this.deviceKey : "",
              // inputContent: this.deviceKey.substring(0, this.deviceKey.lastIndexOf(';'))
            };
            // let arr = [];
            // if (this.configForm.inputContent) {
            //   this.configForm.inputContent.split(";").forEach((item, index) => {
            //     if (item && item.length !== 0) {
            //       arr.push(Dic.findByLabel("SENU098", item));
            //     }
            //   });
            //   params.inputContent = arr.join(";");
            // }
          }
          console.log("===步骤参数====", params);
          this.btnLoading = true;
          this.$fetch(url, params).then((res) => {
            this.btnLoading = false;
            if (res.success) {
              this.$message({
                message: this.state === 1 ? "新增成功" : "修改成功",
                type: "success",
                duration: 2000,
              });
              this.formClose();
              this.$emit("refresh");
            } else {
              this.$message.error(res.msgContent);
            }
          });
        } else {
          return false;
        }
      });
    },
    // 关闭弹框
    formClose() {
      this.formShow = false;
      this.$refs.configForm.resetFields();
      this.deviceKey = "";
      // this.configForm = {
      //   stepName: "",
      //   operationKeyType: "2",
      //   inputContent: "",
      // };
    },
  },
};
</script>
<style lang="scss">
.config-dialog {
  .dialog-scroll {
    height: 400px;
  }
}
</style>
